<template>
    <div class="blackBg  animated slideInLeft">
        <div class="cardTit">
            <span class="season">{{$store.state.seasonName}}</span>
            <span class="teamName">{{teamName?teamName:'XXX'}}</span>
        </div>
        <div class="cardBg">
            <p class="contTit">APHV</p>
            <div class="teamReport">
                <div class="scroll">
                    <ul v-for="(item,ind) in dataList">
                        <li class="itemTitle">{{dataLabelArr[ind]}}</li>
                        <li v-for="itemChild in item[0].players">
                            <p class="playerMsg">
                            <span class="headImg">
                                <img v-if="itemChild.playerAvatar" :src="itemChild.playerAvatar" alt="">
                            <img v-else src="../assets/img/updateImg/headImg.svg" alt="">
                            </span>
                                <span class="name">{{itemChild.playerName}}</span>
                            </p>
                            <p class="num">{{itemChild.aphv}}</p>
                        </li>
                        <li v-if="item[0].players.length==0">暂无数据</li>
                    </ul>
                    <div style="clear: both"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "bodyAPHV",
        computed: {
            teamId() {
                return this.$store.state.teamId;
            }
        },
        data() {
            return {
                teamName: this.$store.state.teamName.split('_')[0],//梯队名称
                dataList: [],//aphv数据
                dataLabelArr: ["Group 1 APHV under -0.5", "Group 2 APHV -0.5 to 0.5", "Group 3 APHV 0.5 to 1.5", "Group 4 APHV over 1.5"],
                scrollDomHeight: 0,//滚动距离
                scrollTime: 0,//滚动时间
                time: null,//定时器
            }
        },
        watch: {
            teamId: {
                handler(val, old) {
                    if (val != old) {
                        this.teamName = this.$store.state.teamName.split('_')[0];//梯队名称
                        this.info()
                    }
                },
                deep: true
            }
        },
        mounted() {
            this.info();
        },
        methods: {
            info() {
                let data = {
                    teamId: this.teamId,
                    year: new Date().getFullYear()
                }
                this.$server.getAphvReport(data)
                    .then((res) => {
                        this.dataList = res.data;

                        let setTime = setTimeout(() => {
                            const lookEl = document.querySelector('.teamReport');
                            const el = document.querySelector('.scroll');
                            this.scrollDomHeight = el.offsetHeight - lookEl.offsetHeight;
                            console.log(this.scrollDomHeight);
                            if (this.scrollDomHeight > 0) {
                                clearInterval(this.time)
                                this.time = setInterval(this.scroll, 8500);
                            }
                            clearTimeout(setTime)
                        }, 100)
                    })
            },
            //滚动数据
            scroll() {
                const el = document.querySelector('.scroll');
                let style = el.getAttribute('style')
                if (style && style == 'margin-top:' + -(this.scrollDomHeight) + 'px') {
                    el.setAttribute('style', 'margin-top:' + 0 + 'px')
                } else {
                    el.setAttribute('style', 'margin-top:' + -(this.scrollDomHeight) + 'px')
                }
            }
        },
        destroyed() {
            clearInterval(this.time)
        }
    }
</script>

<style scoped lang="less">
    .cardTit {
        background-image: url("../assets/img/updateImg/head_2.png");
        font-size: 30px;
        box-sizing: border-box;
        position: relative;

        .season {
            font-family: PingFangMedium;
            color: #fff;
            display: inline-block;
            position: absolute;
            line-height: 130px;
            left: 2vw;
        }
    }

    .cardBg {
        padding: 2vw;
        font-family: PingFangMedium;
        height: calc(100% - 112px);
        width: 100%;

        .contTit {
            color: #fff;
            font-size: 30px;
            height: 2vw;
            line-height: 2vw;
            margin-bottom: .5vw;
        }

        .teamReport {
            height: calc(100% - 2.5vw);
            overflow-y: auto;
            .scroll{
                transition: all 8s linear;
            }
            ul {
                color: #fff;
                margin-left: 1vw;
                width: calc((100% - (1vw * 3)) / 4);
                float: left;
                border: 1px solid rgba(255, 255, 255, .14);
                box-sizing: border-box;
                font-size: 22px;
                border-radius: 3px;

                &:first-child {
                    margin-left: 0;
                }

                li {
                    &:last-child {
                        border-bottom: none;
                    }

                    text-align: center;
                    height: 2.5vw;
                    line-height: 2.5vw;
                    width: 100%;
                    box-sizing: border-box;
                    border-bottom: 1px solid rgba(255, 255, 255, .14);

                    p {
                        float: left;
                    }

                    .playerMsg {
                        width: 60%;
                        padding-left: .8vw;

                        span {
                            float: left;
                            margin-right: .6vw;
                        }

                        .headImg {
                            margin-top: .4vw;
                            width: 1.6vw;
                            height: 1.6vw;
                            border-radius: 50%;
                            overflow: hidden;

                            img {
                                width: 100%;
                            }
                        }
                    }

                    .num {
                        width: 40%;
                        box-sizing: border-box;
                        border-left: 1px solid rgba(255, 255, 255, .14);
                    }
                }

                .itemTitle {
                    font-size: 22px;
                    background: rgba(216, 216, 216, .1);
                    border: none;
                }
            }
        }
    }
</style>
